import { render } from "./AddMonnaieModal.vue?vue&type=template&id=1ea8ec1a&ts=true"
import script from "./AddMonnaieModal.vue?vue&type=script&lang=ts"
export * from "./AddMonnaieModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__